export const toBase64 = ({ content_type, file_blob }) => {
  return `data:${content_type};base64,${file_blob}`;
}
